// Export screens
export { default as CatalogHomeScreen } from './screens/catalog-home-screen';
export { default as CatalogCategoryScreen } from './screens/catalog-category-screen';
export { default as CatalogSearchScreen } from './screens/catalog-search-screen';

// Export types
export type { CatalogPageType } from './types/common';
export type { CatalogEvents } from './events';
export { CatalogEventKeys } from './events';
export type { CatalogViewData } from './types/catalog-view-data';
export type { CategoryTypes, CatalogCategoryInitialData } from './types/catalog-category-data';
export type { CatalogSearchInitialData } from './types/catalog-search-data';

// Export services
export { catalogViewService, getEssentialCatalogData } from './services/catalog';
export { catalogCategoryService } from './services/category';

// Hooks
export * from './hooks/use-profile-catalog-data';
export * from './hooks/use-catalog-favourite';
export * from './hooks/use-category';
export * from './hooks/use-filters';
export * from './hooks/use-search';
export * from './hooks/use-base-filter';
export * from './hooks/use-modal';
export { useNonEssentialCatalogData } from './hooks/use-non-essential-catalog-data';

// Services
export * from './services/api-services';
export * from './services/api-services-authenticated';
export * from './services/filter-builder';
export * from './services/catalog';
export * from './services/category';
export * from './services/filtered-data-service';
export * from './services/search-data-service';
export * from './services/category-data-service';
export * from './services/most-favourite-courses';

// Types
export * from './types/filtered-data';
export * from './types/catalog-category-data';

// Events
export * from './events';
